import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AboutUsSection from "./AboutUsSection";
import FunFactSection from "./FunFactSection";
import ServicesSection from "./ServicesSection";
import TestimonialSection from "./TestimonialSection";
import WhyChooseSection from "./WhyChoose";
import OurProjectSection from "./OurProjectSection";
import { HelmetProvider } from "react-helmet-async";
import Angelinvestor from "./Services/Angelinvestor";
import Header from "./Header";
import Footer from "./Footer";
import NewsFeed from "./NewsFeed";
import ContactUs from "./ContactUs";
import Aboutus from "./About-us";
import Contact from "./Contact-us";
import OurOperations from "./Services/OurOperations";
import Navbar from "./Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import MetaTags from "./MetaTags";
import Dataconsulting from "./Services/Dataconsulting";
import Hospitality from "./Services/Hospitality";
import ManagementConsulting from "./Services/ManagementConsulting";
import SoftwareWebDevelopment from "./Services/SoftwareWebDevelopment";
import AmlyticsAI from "./Products/AmlyticsAI";
import $ from "jquery";
import LandingPageTownsVilleAngelInvestor from "./LandingPageTownsVilleAngelInvestor";
import LandingPageCairnsAngelInvestor from "./LandingPageCairnsAngelInvestor";
import LandingPageRockhamptonAngelInvestor from "./LandingPageRockhamptonAngelInvestor";
import LandingPageBrisbaneAngelInvestor from "./LandingPageBrisbaneAngelInvestor";
import AOS from "aos";
import "aos/dist/aos.css";
import HeaderWithItems from "./Blog/Home";
import FuelingPost from "./Blog/FuelingPost";
import DataPost from "./Blog/DataPost";
import NotFoundPage from "./404Page";
import ScrollToTop from "./ScrollToTop";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./TermsConditions";
import Preloader from "./Components/Preloader";
function ClarityTracker() {
  const location = useLocation();

  useEffect(() => {
    // 1. Initialize Clarity if it hasn't been initialized yet
    if (!window.clarity) {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };

        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;

        y = l.getElementsByTagName(r)[0];
        if (y && y.parentNode) {
          y.parentNode.insertBefore(t, y);
        } else {
          l.head.appendChild(t);
        }
      })(window, document, "clarity", "script", "xnrfxdnziq");
    }

    // 2. Track page view / URL changes
    if (window.clarity) {
      window.clarity("set", "page", location.pathname);
    }
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  const [progressBarsAnimated, setProgressBarsAnimated] = useState(false);

  useEffect(() => {
    $(document).ready(() => {
      const sectionE = $(".consultio_content .banner_bottom_partts").offset()
        ?.top;
      const sectionF = $(".consultio_content .about_us_section").offset()?.top;
      const sectionG = $(".consultio_content .funfact_partts").offset()?.top;
      const sectionL = $(".consultio_content .testimonial_sec").offset()?.top;
      const sectionH = $(".consultio_content .why_choose").offset()?.top;
      const sectionI = $(".consultio_content .services").offset()?.top;
      const sectionK = $(".consultio_content .our_prj").offset()?.top;
      const scrollOffset = 320;

      const handleScroll = () => {
        const scroll = $(window).scrollTop() + scrollOffset;

        if (scroll > sectionE) {
          $(".banner_bottom_innr_partts").addClass("flip_in");
        }
        // Add other scroll-related logic here...
      };

      $(window).scroll(handleScroll);

      return () => {
        $(window).off("scroll", handleScroll);
      };
    });
  }, [progressBarsAnimated]);
  return (
    <>
      <BrowserRouter>
          <ClarityTracker />
          <Preloader />
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Header />
                  <AboutUsSection /> <FunFactSection />
                  <WhyChooseSection />
                  <ServicesSection />
                  <TestimonialSection />
                  {/* <OurProjectSection/> */}
                  <NewsFeed />
                  <ContactUs />
                  <Footer />
                </>
              }
            />

            <Route
              path="/about-us"
              element={
                <>
                  {" "}
                  <Navbar />
                  <Aboutus />
                  <Footer />
                </>
              }
            />

            <Route
              path="/contact-us"
              element={
                <>
                  {" "}
                  <Navbar />
                  <Contact /> <Footer />
                </>
              }
            />
            <Route
              path="/operations"
              element={
                <>
                  <Navbar /> <OurOperations /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/angel-investor"
              element={
                <>
                  <Navbar /> <Angelinvestor /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/management-consulting"
              element={
                <>
                  <Navbar /> <ManagementConsulting /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/software-web-development"
              element={
                <>
                  <Navbar /> <SoftwareWebDevelopment /> <Footer />
                </>
              }
            />
            <Route
              path="/products/amlyticsai"
              element={
                <>
                  <Navbar /> <AmlyticsAI /> <Footer />
                </>
              }
            />
            <Route
              path="/blog"
              element={
                <>
                  <Navbar /> <HeaderWithItems /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/data-science-services-australia"
              element={
                <>
                  <Navbar /> <Dataconsulting /> <Footer />
                </>
              }
            />
            <Route
              path="/blog/unveiling-the-magic-of-data-consulting"
              element={
                <>
                  <Navbar /> <DataPost /> <Footer />
                </>
              }
            />
            <Route
              path="/blog/the-role-of-angel-investor"
              element={
                <>
                  <Navbar /> <FuelingPost /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/angel-investor/townsville"
              element={
                <>
                  <Navbar /> <LandingPageTownsVilleAngelInvestor /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/angel-investor/cairns"
              element={
                <>
                  <Navbar /> <LandingPageCairnsAngelInvestor /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/angel-investor/rockhampton"
              element={
                <>
                  <Navbar /> <LandingPageRockhamptonAngelInvestor /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/angel-investor/brisbane"
              element={
                <>
                  <Navbar /> <LandingPageBrisbaneAngelInvestor /> <Footer />
                </>
              }
            />
            <Route
              path="/operations/hospitality"
              element={
                <>
                  <Navbar /> <Hospitality /> <Footer />
                </>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <>
                  <Navbar /> <PrivacyPolicy /> <Footer />
                </>
              }
            />
            <Route
              path="/terms-conditions"
              element={
                <>
                  <Navbar /> <TermsConditions /> <Footer />
                </>
              }
            />
			<Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
    </>
  );
}

export default App;
